import React from 'react';
import { FaLock } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';

import {
  Header,
  LogoSection,
  GovLogoImg,
  MedsusLogoImg,
  HeaderTitle,
  HeaderNav,
  RestrictedAreaButton,
  VerticalDivider,
  VerticalDividerSmall,
  MedicamentosLink,
} from './styles';
import logoGovBr from '../../../assets/logo_govbr.svg';
import logoMedsus from '../../../assets/logo_medsus.png';

export function MedsusPublicHeader() {
  const navigate = useNavigate();

  return (
    <Header>
      <LogoSection>
        <GovLogoImg src={logoGovBr} alt="Gov.br" />
        <VerticalDivider />
        <MedsusLogoImg src={logoMedsus} alt="MedSUS" />
        <VerticalDividerSmall />
        <HeaderTitle>MEDSUS</HeaderTitle>
      </LogoSection>
      <HeaderNav>
        <MedicamentosLink
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate('/medsus');
          }}
        >
          Medicamentos
        </MedicamentosLink>
        <RestrictedAreaButton
          onClick={() => navigate('/')}
          title="Acesso restrito ao sistema"
        >
          <FaLock style={{ color: '#fff' }} />
          Área Restrita
        </RestrictedAreaButton>
      </HeaderNav>
    </Header>
  );
}
